import { v4 as uuid } from 'uuid';
import { Converter, deserialize } from './json-mapper';
import { jwtDecode } from 'jwt-decode';

export const uidConverter: Converter = {
  fromJson() {
    return uuid();
  },
};

export const parseJWTConverter = <T>(Type: new () => T, key?: string): Converter => {
  return {
    fromJson(value: any, json: any): T {
      const token = key ? json[key] : value;
      return token ? deserialize<T>(Type, jwtDecode(token)) : void 0;
    },
  };
};
